import { useQuery } from "@tanstack/react-query";
import { fetchOverviewData } from "@app/services/overviewApi";
import type { OverviewDataPayload } from "@shared/types/overview";

const OVERVIEW_QUERY_KEY = ["overview", "dashboard"];

export function useOverviewData() {
  return useQuery<OverviewDataPayload>({
    queryKey: OVERVIEW_QUERY_KEY,
    queryFn: fetchOverviewData,
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
    refetchInterval: false,
    refetchOnWindowFocus: false,
    retry: 1,
  });
}

